module.exports = __webpack_public_path__ + "teethlaugh.650cc2d8.png";